import { IonChip, IonIcon, IonLabel } from '@ionic/react'
import { useStore } from 'effector-react'
import { bulb } from 'ionicons/icons'
import { viewerModel } from '~/entities/viewer'
import { logoutFx } from '~/entities/viewer/model'
import { pushFx } from '~/shared/lib/history'
import { Button } from '~/shared/ui/Buttons'

type TaxiparkWarningProps = {
  taxiparkName?: string
  taxiparkId?: UniqueId
}

export function TaxiparkWarning({
  taxiparkName,
  taxiparkId,
}: TaxiparkWarningProps) {
  const logoutPending = useStore(logoutFx.pending)
  const handleGoToRegistration = async () => {
    await viewerModel.logoutFx()
    pushFx(`/registration?taxiparkId=${taxiparkId}`)
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <IonChip color='primary'>
        <IonIcon icon={bulb}></IonIcon>
        <IonLabel>
          Чтобы арендовать автомобиль в таксопарке {taxiparkName}, укажите его в
          качестве основного в настройках таксопарка. Если вы ещё не
          зарегистрированы в этом таксопарке — пройдите простую регистрацию на
          странице авторизации, чтобы получить доступ к автопарку и начать
          работу. После подтверждения регистрации вы сможете выбрать и
          арендовать автомобиль прямо в приложении.
        </IonLabel>
      </IonChip>

      <Button fullWidth variant='lightSteelBlueBorder' to='/taxiparks'>
        Перейти в настройки Таксопарка
      </Button>

      <Button
        fullWidth
        variant='blueFlooded'
        onClick={handleGoToRegistration}
        loading={logoutPending}
      >
        Выйти и Зарегистрироваться
      </Button>
    </div>
  )
}
